import axios from 'axios';
import { AnimatePresence, motion } from "framer-motion";
import * as moment from 'moment';
import PullToRefresh from 'pulltorefreshjs';
import React, { Component, createRef, Suspense } from 'react';
import { Button, Col, Modal, Row, Card } from 'react-bootstrap';
import { CastButton, CastProvider } from 'react-cast-sender';
import CountUp from 'react-countup';
import ReactDOMServer from 'react-dom/server';
import Fullscreen from "react-full-screen";
import Scrollbar from "react-scrollbars-custom";
import { BarLoader, MoonLoader } from "react-spinners";
import { Swipeable } from 'react-swipeable';
import { cssTransition, toast } from 'react-toastify';
import { AuthCheck } from 'reactfire';
import ProBadge from '../1Atoms/ProBadge';
import SignOut from '../1Atoms/SignOutButton';
import BeautifulMessage from '../2Molecules/BeautifulMessage';
import ErrorBoundary from '../3Organisms/ErrorBoundary';
import FirebaseUI from '../3Organisms/FirebaseUI';
import firebase from 'gatsby-plugin-firebase'
//misc
import ThemeContext from '../helpers/ThemeContext';
import Login from '../Login'
import Signup from '../Signup'
import Profile from '../Profile'




class Weather extends Component {
  constructor(props) {
    super(props);

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.cityInputRef = createRef();
    this.weatherRef = createRef();
    this.todayRef = createRef();
    this.citiesList = createRef();
    this.citiesRef = {};
  }

  state = {
    displayLogin : 'block',
    displaySignup : 'none',
    loading: true,
    timeToday: new Date().toLocaleTimeString(),
    dateToday: new Date().toDateString(),
    dateTime: null,
    weatherToday: null,
    weatherPrevious: null,
    offset: 0,
    forecast: null,
    weatherError: false,
    videoImage: null,
    city: "vancouver",
    cities: (typeof window !== "undefined" && JSON.parse(localStorage.getItem("weatherAppLocations"))) || ["Vancouver"],
    isNight: false,
    todayExpanded: false,
    monExpanded: false,
    tuesExpanded: false,
    wedsExpanded: false,
    thursExpanded: false,
    friExpanded: false,
    satExpanded: false,
    sunExpanded: false,
    activeTab: (typeof window !== "undefined" && JSON.parse(localStorage.getItem("activeTab"))) || 0,
    showLocationModal: false,
    updated: new Date(),
    showMenu: false,
    newCity: "",
    error: false,
    errorMsg: "",
    pip: false, //force disable piccture in picture mode in React Player
    addLocationError: false,
    tempUnit: true, //metric or imperial => celcius or fahrenheit
    tempValue: "metric", //metric or imperial => celcius or fahrenheit
    showAccount: false,
    showSettings: false,
    showSettings2: false,
    showDeleteModal: false,
    deleteLocation: false,
    cityBgUrl: "",
    showLogin: false,
    showNotification: false,
    showNotification2: false,
    onlineCount: 0,
    notificationMessage: "",
    fullScreenActive: false,
    weatherDOM: null,
    helpActive: false,
    videoReady: false,
    screenWidth: null,
    deleted: "",
    weatherDetails: (typeof window !== "undefined" && JSON.parse(localStorage.getItem("weatherDetails"))) || false,
    showForecast: false,
    showArrows: (typeof window !== "undefined" && JSON.parse(localStorage.getItem("showArrows"))) || false,
    stickyForecast: false,
    shouldPullToRefresh: true,
    isProUser: false,
    wasOffline: (typeof window !== "undefined" && JSON.parse(localStorage.getItem("wasOffline"))) || false,
    showNetworkMsg: false,
    networkMsg: null,
    displayLogin : 'block',
    displaySignup : 'none',
    displayProfile : 'none',
    wrapperText : '',
    user : false
  }

  persistToLocalStorage(array) {
    typeof window !== "undefined" && localStorage.setItem("weatherAppLocations", JSON.stringify(array));
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
     if(user)  this.setState({user : true, wrapperText : 'Profile'})
        else   this.setState({wrapperText : 'Login'})
    })
    this.setState({displayProfile : 'block'})
    typeof window !== "undefined" && window.addEventListener("resize", this.updateWindowDimensions());
    this.props.online && this.getweatherToday(this.state.cities[this.state.activeTab]);
    this.props.online && this.getWeatherData(this.state.cities[this.state.activeTab]);

    this.interval = setInterval(() => {
      this.props.online && this.getweatherToday(this.state.cities[this.state.activeTab]);
      this.props.online && this.getWeatherData(this.state.cities[this.state.activeTab]);
      console.log("weather updated")
    }, 14 * 60 * 1000); //update weather every 14 minutes
    
    document.addEventListener("mousedown", this.handleClickOutside); 
    
    if(!sessionStorage.active || sessionStorage.active == window.location.href) {
      typeof window !== "undefined" && (JSON.parse(localStorage.getItem("showForecast")) === null && localStorage.setItem("showForecast", JSON.stringify(true)));
      this.setState({showForecast: typeof window !== "undefined" && JSON.parse(localStorage.getItem("showForecast"))})
    } 
    else {
      this.setState({showForecast: typeof window !== "undefined" && JSON.parse(localStorage.getItem("showForecast"))})
    }
    sessionStorage.active = window.location.href;

    let that = this;
    //pull to refresh
    PullToRefresh.init({
      mainElement: 'section',
      instructionsPullToRefresh: 'Refresh?',
      instructionsRefreshing: that.props.online ? 'Refresh...' : "Offline",
      onRefresh() {
        that.props.online && that.getweatherToday(that.state.cities[that.state.activeTab]);
        that.props.online && that.getWeatherData(that.state.cities[that.state.activeTab]);
      },
      iconArrow: ReactDOMServer.renderToString(
        <i className="-sun"></i>
      ),
      iconRefreshing: ReactDOMServer.renderToString(
        <i className="-sun rotate"></i>
      ),
      shouldPullToRefresh() {
        return that.state.shouldPullToRefresh === true
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false); 
    document.removeEventListener("mouseup", this.handleClickOutside, false); 
    window.removeEventListener("resize", this.updateWindowDimensions);
    clearInterval(this.interval);
    clearInterval(this.timezoneInterval);

    PullToRefresh.destroyAll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.online !== this.props.online) {
      this.setState({wasOffline: true}, ()=> typeof window !== "undefined" && localStorage.setItem("wasOffline", JSON.stringify(this.state.wasOffline)));
    }
  }

  handleClickOutside(e) {
    this.setState({shouldPullToRefresh: false});
  }

  updateWindowDimensions() {
    this.setState({ screenWidth: typeof window !== "undefined" && window.innerWidth || "100vw"});
  }

  closeAllModals() {
    this.setState({
      showDeleteModal: false,
      showLocationModal: false,
      showSettings: false,
      showSettings2: false
    });

    this.props.showLogin === true && this.props.setShowLogin(false);
  }

  disablePIP() {
    this.setState({ pip: false })
  }

  getweatherToday(cityPassedIn, reset) {
    let city = cityPassedIn || ("Vancouver" || "user's default city");
    axios
      .get("https://api.openweathermap.org/data/2.5/weather?q="+ city + "&appid=" + process.env.GATSBY_WEATHER_API+"&units="+this.state.tempValue)
      .then(response => {
        // console.log("response", response.data);
        if (response.data === "") { // handle success
          this.props.online && this.getweatherToday(city);
        }
        this.setState({ 
          videoReady: false,
          // dateToday: new Date(response.data.dt * 1000).toDateString(),
          // timeToday: new Date(response.data.dt * 1000).toLocaleTimeString(),
          weatherPrevious: this.state.weatherToday,
          weatherToday: response.data, 
          updated: new Date(),
          error: false, 
          loading: false, 
        })
      })
      .catch(error => {
        console.log(error); // handle error
        if (reset === true) {
          this.setState({ dateToday: null, timeToday: null, weatherToday: null, error: true});
        }
        else {
          this.setState({ timeToday: null, weatherToday: null, error: true});
        }
      })
  }
  
  getWeatherData(cityPassedIn, reset) {

    let city = cityPassedIn || ("Vancouver" || "user's default city");
    axios
      .get("https://api.openweathermap.org/data/2.5/forecast?q="+ city + "&appid=" + process.env.GATSBY_WEATHER_API+"&units="+this.state.tempValue)
      .then(response => {
        // console.log("response", response.data);
        if (response.data === "") { // handle success
          this.getWeatherData(city);
        }
        this.setState({ forecast: response.data, error: false, addLocationError: false, updated: new Date(), loading: false });
      })
      .catch(error => {
        // console.log(error.message); // handle error
        if (reset === true) {
          this.setState({ forecast: null, timeToday: null, weatherToday: null, error: true});
        }
        else {
          this.setState({ timeToday: null, weatherToday: null, error: true});
        }
      })
  }

  convertToDay(timestamp) { //day of week - string
    if (this.state.weatherToday) {
      var dateString = moment.unix(timestamp);
      let date = new Date(dateString).toUTCString();
      let offset = this.state.weatherToday.timezone/60;
      let dateTime = moment.utc(date).utcOffset(offset).format('dddd');

      return dateTime;
    }
    else {
      return "0";
    }
  }  
  
  expand(day) {
    switch(day) {
      case "today": {
        this.setState({todayExpanded: !this.state.todayExpanded});
        break;
      }
      case "monday": {
        this.setState({monExpanded: !this.state.monExpanded});
        break;
      }
      case "tuesday": {
        this.setState({tuesExpanded: !this.state.tuesExpanded});
        break;
      }    
      case "wednesday": {
        this.setState({wedsExpanded: !this.state.wedsExpanded});
        break;
      }    
      case "thursday": {
        this.setState({thursExpanded: !this.state.thursExpanded});
        break;
      }    
      case "friday": {
        this.setState({friExpanded: !this.state.friExpanded});
        break;
      }    
      case "saturday": {
        this.setState({satExpanded: !this.state.satExpanded});
        break;
      }    
      case "sunday": {
        this.setState({sunExpanded: !this.state.sunExpanded});
        break;
      }    
    }
  }

  closeAllForecasts() {
    this.setState({
      todayExpanded: false,
      monExpanded: false,
      tuesExpanded: false,
      wedsExpanded: false,
      thursExpanded: false,
      friExpanded: false,
      satExpanded: false,
      sunExpanded: false,
    });
  }

  switchTab(city, index) {
    if (this.props.online) {
      this.setState({activeTab: index, city: city}, ()=> {
        this.props.online && this.getweatherToday(city, true);
        this.props.online && this.getWeatherData(city, true);
        typeof window !== "undefined" && localStorage.setItem("activeTab", JSON.stringify(this.state.activeTab))
      });

      if(index !== this.state.deleteLocation) {
        this.setState({deleteLocation: null});
      }

      //close all expanded forecasts
      this.closeAllForecasts();
    }
    else {
      this.setState({showNotification: true, notificationMessage: "Offline. Cannot load forecast..."})
    }
  }

  toggleLocationModal() {
    this.setState({showLocationModal: !this.state.showLocationModal, error: false, addLocationError:false, errorMsg:""});
  }
  
  toggleHelp() {
    this.setState({helpActive: !this.state.helpActive});
  }
  
  toggleDeleteModal() {
    this.setState({showDeleteModal: !this.state.showDeleteModal});

    if (this.state.showDeleteModal) {
      this.setState({deleteLocation: null})
    }
  }
  
  confirmDeleteLocation() {
    let city = this.state.cities[this.state.deleteLocation];
    this.deleteLocation(this.state.deleteLocation);
    this.toggleDeleteModal();
    this.notifyUser(city+" deleted successfully");
  }

  notifyUser(message) {
    this.setState({showNotification: true, notificationMessage: message});
  }
  
  toggleMenu() {
    this.setState({showMenu: !this.state.showMenu});
  }

  toggleForecast() {
    this.setState({showForecast: !this.state.showForecast}, ()=> 
    {
      typeof window !== "undefined" && localStorage.setItem("showForecast", JSON.stringify(this.state.showForecast))
      if(!this.state.showForecast) { this.setState({shouldPullToRefresh: true}) }
    });
    
  }
  
  toggleArrows() {
    this.setState({showArrows: !this.state.showArrows}, () => typeof window !== "undefined" && localStorage.setItem("showArrows", JSON.stringify(this.state.showArrows)));
    const data = JSON.parse(localStorage.getItem("AppUser"))
    if(data.isActive) {
      firebase.firestore().collection('users').doc(data.uid).set({
        settings : {
          showArrows : !this.state.showArrows
        }
      }, {merge:true})
    }
  }
  
  toggleStickyForecast() {
    this.setState({showForecast: !this.state.showForecast});
  }
  
  toggleLogin() {
    this.closeAllModals();
        
    this.setState({showLogin: !this.state.showLogin}, ()=> {
      if (this.state.showLogin === true) {
        this.toggleAccount();
      }
    });
    this.props.showLogin === true && this.props.setShowLogin(!this.props.showLogin);
  }
  
  toggleAccount() {
    this.setState({showAccount: !this.state.showAccount}, ()=> {
      if (this.state.showAccount) {
        this.setState({showSettings: false, showSettings2: false})
      }
    });
  }
  
  toggleSettings() {
    this.setState({showSettings: !this.state.showSettings}, ()=> {
      if (this.state.showSettings) {
        this.setState({showAccount: false, showSettings2: false})
      }
    });
  }
  
  toggleSettings2() {
    this.setState({showSettings2: !this.state.showSettings2}, ()=> {
      if (this.state.showSettings2) {
        this.setState({showAccount: false, showSettings: false})
      }
    });
  }
  
  toggleNotification() {
    toast.dismiss(); //hide react-toastify toast
    this.setState({showNotification: !this.state.showNotification}, ()=> {
      if (!this.state.showNotification) {
        this.setState({notificationMessage: null});
      }
    })
  }
  
  toggleNotification2() {
    this.setState({showNotification2: !this.state.showNotification2}, ()=> {
      if (!this.state.showNotification) {
        this.setState({notificationMessage: null})
      }
    })
  }

  addLocation() {
    let tempArray = this.state.cities;
    const index = tempArray.indexOf(this.state.newCity);

    if (tempArray.includes(this.state.newCity)) { 
      this.setState({error: true, errorMsg: this.state.newCity +" is already being tracked."});
    }
    else {
      axios
        .get("https://api.openweathermap.org/data/2.5/forecast?q="+ this.state.newCity + "&appid=" + process.env.GATSBY_WEATHER_API+"&units="+this.state.tempValue)
        .then(response => {
          this.setState({ error: false, addLocationError: false, loading: false }, ()=> {
            if (index === -1 && this.state.newCity !== "" && this.state.error === false && this.state.addLocationError === false ) {
              tempArray.push(this.state.newCity);
              this.setState({showLocationModal: false, cities: tempArray, newCity:"", error: false, addLocationError: false});
              const data = JSON.parse(localStorage.getItem("AppUser"))
              if(data.isActive) {
                firebase.firestore().collection('users').doc(data.uid).update({
                  cities : tempArray
                })
              } else {
                console.log("You don't have active membership your cities are temprary")
              }
              let innerIndex = this.state.cities.length-1;
              // this.switchTab(tempArray[innerIndex], innerIndex);
              this.persistToLocalStorage(tempArray);
              this.notifyUser(tempArray[innerIndex]+" added successfully");
            }
            if (this.state.newCity === "" || !this.state.newCity.trim().length) { // check if string is empty
              this.setState({error: true, errorMsg: "Please enter a valid city/country."});
            }
          });
        })
        .catch(error => {
          this.setState({ addLocationError: true , error: true}, ()=> {
            if (this.state.addLocationError || this.state.error) {
              this.setState({error: true, errorMsg: this.props.online ? this.state.newCity+" is an invalid weather location" : "Sorry, I can't add a new location while offline"});
            }
          });
        })    
    }
    // // scroll into view
    // this.refs.citiesList.current.scrollIntoView({
    //   behavior: 'smooth',
    //   inline: 'end',
    // });
  }

  handleChange(e) {
    if (e.target.name) {  
      switch(e.target.name) {
        case "city": {
          this.setState({newCity: e.target.value, error: false, addLocationError:false});
          if((e.key === "Enter" || e.keyCode === 13)) {
            this.addLocation();
          }
          break;
        }

        case "unit": {
          this.toggleUnit();
          break;
        }
      }
    }
    else {
      switch(e.target.id) {
        case "account": {
          if(e.key=='Escape'|| e.key=='Esc'||e.keyCode==27){
            this.closeAllModals();
          }
          if((e.key === "Enter" || e.keyCode === 13)) {
            this.toggleAccount();
          }
          break;
        }
        case "settings": {
          if(e.key=='Escape'|| e.key=='Esc'||e.keyCode==27){
            this.closeAllModals();
          }
          if((e.key === "Enter" || e.keyCode === 13)) {
            this.toggleSettings();
          }
          break;
        }
        case "settings2": {
          if(e.key=='Escape'|| e.key=='Esc'||e.keyCode==27){
            this.closeAllModals();
          }
          if((e.key === "Enter" || e.keyCode === 13)) {
            this.toggleSettings2();
          }
          break;
        }
      }
    }
  }

  todayWeatherValue(value) {
    let weather = parseFloat(value).toFixed(0);

    if (weather === "-0") {
      weather = "0";
    }

    return weather;
  }

  generateExpandedCell(forecast, index) {
      return <ErrorBoundary msg="Error loading forecast details"><div className="summary">{index}</div></ErrorBoundary>;
  }

  focusInput = (component) => {
    if (component) {
      component.focus();
    }
  };

  todayWeatherLogo(weather) {
    switch(weather) {
      case "Rain": {
        return <div className="rainy scale-in-center" title={weather}></div>;
      }
      case "Clouds":
      case "Mist":  
      {
        return <div className="cloudy scale-in-center" title={weather}></div>;
      }
      case "Snow": {
        return <div className="snowy scale-in-center" title={weather}></div>;
      }
      case "Sun": {
        return <div className="sunny scale-in-center" title={weather}></div>;
      }
      case "Storm": {
        return <div className="stormy scale-in-center" title={weather}></div>;
      }
      case "Rainbow": {
        return <div className="rainbow scale-in-center" title={weather}></div>;
      }
      case "Stars": {
        return <div className="starry scale-in-center" title={weather}></div>;
      }

      default: {
        return <div className="sunny scale-in-center" title={weather}></div>
      }
    } 

  }

  handleButtonPress(index) {
    this.buttonPressTimer = setTimeout(() => this.setState({deleteLocation: index}), 1000);
  }

  handleButtonRelease () {
    clearTimeout(this.buttonPressTimer);
  }

  deleteLocation(index) {
    let temp = this.state.cities;
    temp.splice(index, 1);

    this.setState(
      {
        activeTab: 0, 
        cities: temp, 
        city: temp[0],
        deleteLocation: null
      }, ()=> {
        let innerIndex = 0; //to go back one entry after deletion
        if (index-1 < 0) {
          innerIndex = 0;
        }
        else {
          innerIndex = index - 1;
        }

        this.props.online && this.getweatherToday(temp[innerIndex]);
        this.props.online && this.getWeatherData(temp[innerIndex]);
        typeof window !== "undefined" && localStorage.setItem("activeTab", JSON.stringify(this.state.activeTab));
        this.switchTab(temp[innerIndex], innerIndex); //go to first tab
    });

    this.persistToLocalStorage(temp);
  }

  toggleUnit() {
    this.setState({tempUnit: !this.state.tempUnit}, ()=> {
      this.props.online && this.getweatherToday(this.state.city);
      this.props.online && this.getWeatherData(this.state.city);
    });

    
    if(this.state.tempUnit) {
      this.setState({tempValue:"imperial"});
    }
    else {
      this.setState({tempValue: "metric"});
    }
  }

  toggleDetails() {
    this.setState({weatherDetails: !this.state.weatherDetails}, () => typeof window !== "undefined" && localStorage.setItem("weatherDetails", JSON.stringify(this.state.weatherDetails)));
    const data = JSON.parse(localStorage.getItem("AppUser"))
              if(data.isActive) {
                firebase.firestore().collection('users').doc(data.uid).set({
                  settings : {
                    weatherDetails : !this.state.weatherDetails
                  }
                }, {merge:true})
              }
  }

  toggleFullScreen() {
    this.setState({fullScreenActive: !this.state.fullScreenActive});
    
  }

  loading(type) {
    if (this.state.error) {
      return <div className={type +"-error"}><i className="-cloud mr-2"></i>{this.state.cities && this.state.cities.length < 1 ? "No Forecast available." : "Error loading forecast"}</div>
    }
    
    if (!this.props.online) {
      return <div className={type +"-error"}><i className="-exclamation-circle mr-2"></i>Can't load forecast while offline.</div>
    }

    return <BarLoader
      width={100}
      height={2} 
    />
  }

  render() {
    const {
      dateToday, 
      timeToday, 
      weatherToday, 
      weatherPrevious, 
      forecast, 
      cities,
      todayExpanded,
      monExpanded,
      tuesExpanded,
      wedsExpanded,
      thursExpanded,
      friExpanded,
      satExpanded,
      sunExpanded,
      activeTab,
      showLocationModal,
      newCity,
      error,
      errorMsg,
      tempUnit,
      showAccount,
      showLogin,
      showSettings,
      showSettings2,
      showDeleteModal,
      deleteLocation,
      cityBgUrl,
      showMenu,
      showNotification,
      showNotification2,
      notificationMessage,
      fullScreenActive,
      helpActive,
      screenWidth,
      pip,
      weatherDetails,
      showForecast,
      showArrows,
      isNight,
      updated,
    } = this.state;

    const containerDetailsRight = {
      hidden: { opacity: 0 },
      show: {
        opacity: 1,
        translateX: 0,
        transition: {
          staggerChildren: 0.2,
          delayChildren: 0.2,
        }
      },
      exit: { 
        opacity: 0,
        translateX: 50,
        transition: {
          staggerChildren: 0.2,
          delayChildren: 0.3,
        } 
      },
    }

    const containerDetailsLeft = {
      hidden: { opacity: 0, height: 0 },
      show: {
        opacity: 1,
        height: "100%",
        translateX: 0,
        transition: {
          staggerChildren: 0.2,
          delayChildren: 0.2,
        }
      },
      exit: { 
        opacity: 0,
        height: 0,
        translateX: 50,
        transition: {
          staggerChildren: 0.2,
          delayChildren: 0.3,
        } 
      },
    }
    
    const itemDetailsRight = {
      hidden: { opacity: 0, translateX: 50 },
      show: { opacity: 1, translateX: 0 },
    }
    
    const itemDetailsLeft = {
      hidden: { opacity: 0, translateX: -50 },
      show: { opacity: 1, translateX: 0 }
    }

    // const user = getProfile() || "Blank User :(";


    // let user = null;
    
    // fetch(this.props.user)
    // .then(({user}) => {
    //   user = user;
    // });

    // console.log("all states", this.state);
    // console.log("all props", this.props);
    // console.log("user props", this.props.user);
    // console.log("display name", this.props.user.displayName !== undefined && this.props.user.displayName || "loading");
    // console.log("all refs", this.refs);

    const toastAnimation = cssTransition({
      enter: 'fade-in-bottom',
      exit: 'fade-out-top',
      duration: [500, 800] // zoomIn will last 500ms while zoomOut will last 800ms
    });



    return <ThemeContext.Consumer>
      {theme => (
      <Fullscreen
        enabled={fullScreenActive}
        onChange={fullScreenActive => this.setState({fullScreenActive})}
      >
        <div className={`weather fade-in ${theme.color} ${showLocationModal && "blur"}`} id="weather" ref={this.weatherRef}>

            <div className="today px-4 py-3 text-left" ref={node => this.todayRef = node}>
              <Row>
                <div className="notification-wrapper">
                  {showNotification &&
                    !toast.isActive("user-alert") &&
                      toast(notificationMessage, {
                        position: "top-center",
                        autoClose: 4800,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: 0,
                        toastId: "user-alert",
                        transition: toastAnimation,
                        onClose: () => this.toggleNotification()
                      })
                    }
                </div>
                { 
                  <div className="notification-wrapper">
                    {(!this.props.online && !this.props.loading) &&
                      !toast.isActive("offline") &&
                        toast("Lost Internet Connection", {
                          position: "top-center",
                          autoClose: 2800,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: 0,
                          toastId: "offline",
                          transition: toastAnimation,
                          // onClose: () => this.toggleNotification()
                        })
                    }
                  </div>
                }

                <ErrorBoundary msg="Error loading menu">
                      <span className="settings-menu">
                      
                        {showAccount && <div className="overlay" onClick={()=>this.toggleAccount()}></div>}

                        <span 
                          id="account"
                          ref={node => this.settingsRef = node}
                          tabIndex="99"
                          className={`account ${showAccount && "active"} ${this.props.user && "loggedIn"} fade-in-right`} 
                          onClick={()=> {this.toggleAccount()}}
                        >
                          <i className=" ">{this.state.wrapperText}</i>
                          {/* {this.props.user && <ProBadge />} */}
                          { showAccount &&
                            <div className="settings-wrapper" style={{display : this.state.displayProfile}} onClick={(e)=>e.stopPropagation()}>
                              { !this.state.user ? 
                                <div >
                                    {/* <BeautifulMessage free /> */}
                                    <div style={{display : this.state.displayLogin}}>
                                    <Login />
                                     
                                  <span style={{marginTop:15,cursor:'pointer'}} onClick={() => this.setState({displayLogin :'none', displaySignup : 'block'})}>Signup</span>
                                  </div>
                                  <div style={{display : this.state.displaySignup}}>
                                   <Signup />
                                   <span style={{marginTop:15,cursor:'pointer'}} onClick={() => this.setState({displayLogin :'block', displaySignup : 'none'})}>Back to Login</span>
                                  </div>
                                </div>
                                :
                                <Profile />
                              }                     
                            </div>
                          }
                        </span> 
                        {showSettings && <div className="overlay" onClick={()=>this.toggleSettings()}></div>}
                        <span 
                          id="settings"
                          ref={node => this.settingsRef = node}
                          tabIndex="99"
                          className={`settings ${showSettings && "active"} fade-in-right`} 
                          onClick={()=> this.toggleSettings()}
                        >
                          <i className=" ">Settings</i>
                          <h1 className="header">Settings</h1>
                          { showSettings &&
                            <div className="settings-wrapper" onClick={(e)=>e.stopPropagation()}>
                              <Row className="setting">
                                <Col xs={6}>Unit: </Col>
                                <Col xs={6}>
                                  <Row>
                                    <Col xs={12}>
                                      <label className="switch" >
                                        <input name="unit" type="checkbox" checked={this.state.tempUnit} onChange={() => this.toggleUnit()} />    
                                        <div></div>
                                      </label>
                                      <span className="switch-info">
                                        {
                                          tempUnit ?
                                          <span className="celcius" onClick={() => this.toggleUnit()}>°C</span>
                                          :
                                          <span className="fahrenheit" onClick={() => this.toggleUnit()}>°F</span>
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="setting disabled">
                                <Col xs={6}>Weather Info: </Col>
                                <Col xs={6}>
                                  <Row>
                                    <Col xs={12}>
                                      <label className="switch" >
                                        <input name="details" type="checkbox" checked={this.state.weatherDetails} onChange={() => this.toggleDetails()} />    
                                        <div></div>
                                      </label>
                                      <span className="switch-info">
                                        {
                                          weatherDetails ?
                                          <span className="celcius" onClick={() => this.toggleDetails()}>Detailed</span>
                                          :
                                          <span className="fahrenheit" onClick={() => this.toggleDetails()}>Simple</span>
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="setting">
                                <Col xs={6}><i className="-cloud"></i> Forecast: </Col>
                                <Col xs={6}>
                                  <Row>
                                    <Col xs={12}>
                                      <label className="switch" >
                                        <input name="theme" type="checkbox" checked={showForecast} onClick={() => this.toggleForecast()} />    
                                        <div></div>
                                      </label>
                                      <span className="switch-info">
                                        {
                                          showForecast === true ?
                                          <span className="" onClick={() => this.toggleForecast()}>Visible</span>
                                          :
                                          <span className="" onClick={() => this.toggleForecast()}>Hidden</span>
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="setting">
                                <Col xs={6}> Quick View: </Col>
                                <Col xs={6}>
                                  <Row>
                                    <Col xs={12}>
                                      <label className="switch" >
                                        <input name="theme" type="checkbox" checked={showArrows} onClick={() => this.toggleArrows()} />    
                                        <div></div>
                                      </label>
                                      <span className="switch-info">
                                        {
                                          showArrows === true ?
                                          <span className="" onClick={() => this.toggleArrows()}>On</span>
                                          :
                                          <span className="" onClick={() => this.toggleArrows()}>Off</span>
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row className="setting">
                                <Col xs={6}>Theme: </Col>
                                <Col xs={6}>
                                  <Row>
                                    <Col xs={12}>
                                      <span className="switch-info theme">
                                        {
                                          theme.color === "dark" ?
                                          <span className="" onClick={() => theme.toggleTheme("light")}>{theme.color}</span>
                                          :
                                          <span className="" onClick={() => theme.toggleTheme("dark")}>{theme.color}</span>
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              
                            </div>
                          }
                        </span> 
                        
                        { /*(this.props.online && CastButton)*/ false &&
                            <span 
                              id="cast"
                              ref={node => this.settingsRef = node}
                              tabIndex="99"
                              className={`cast fade-in-right`} //${showAccount && "active"} fade-in-right`} 
                            >
                              <span className="cast-btn-wrapper">
                                {typeof window !== 'undefined' && CastProvider && <CastButton />}
                              </span>
                            </span>
                          }
                      </span>
                    </ErrorBoundary>

              <ErrorBoundary msg="Error loading today's weather">
                <section className="col">
                  <Col xs={6} className="temp-parent">
                    <Row className="city mt-1 fade-in">
                      <Col><span>{(weatherToday && (weatherToday.name +", "+weatherToday.sys.country)) || ((!this.props.online && !this.props.loading) ? "Offline" : " ")}</span></Col>
                    </Row>
                    <div className="temp-wrapper fade-in">
                      <Row>
                        <Col>
                          <h1 className="temperature">
                            { weatherToday ?
                              <CountUp 
                                start={(weatherPrevious && this.todayWeatherValue(weatherPrevious.main.temp)) || 0}
                                end={parseFloat(weatherToday && this.todayWeatherValue(weatherToday.main.temp)).toFixed(0) || 0} 
                                duration={1}
                              />:
                              '0'
                            }
                            <small>°</small>
                          </h1>
                        </Col>
                      </Row>
                      <Row>
                        <Col><p className="temp-desc fade-in">{(weatherToday && weatherToday.weather[0].description) || ""}</p></Col>
                      </Row>
                      <Row>
                        <Col><span className="feels-like">Feels Like {(weatherToday && parseFloat(weatherToday.main.feels_like).toFixed(0)) || "0"}<span className="deg">°</span></span></Col>
                      </Row>
                      {/* <AnimatePresence> */}
                      { (weatherDetails && !showForecast) && 
                        <div 
                          className="details-left feels-like row"
                        >
                          <div key={3} className="col-12"><span>High: </span> <span className="title">{weatherToday && parseFloat(weatherToday.main.temp_max).toFixed(0) || "0"}</span><small className="deg">°</small></div>
                          <div key={4} className="col-12"><span>Low: </span> <span className="title">{weatherToday && parseFloat(weatherToday.main.temp_min).toFixed(0) || "0"}</span><small className="deg">°</small></div>
                         
                        </div>
                      }
                    </div>
                    
                  </Col>
                </section>
              </ErrorBoundary>
              </Row>
            </div>
            <AnimatePresence>
            { !this.props.loading &&                
              <motion.div 
                className={showForecast ? "forecast" : "forecast__inactive"}
                // initial={{ opacity: 0, height: "0vh" }}
                // animate={{ opacity: 1, height: "55vh" }}
                // exit={{ opacity: 1, height: "0vh" }}
              >
                <Row className={(cities.length>2 && !fullScreenActive) ? "cities multiple" : "cities"} ref={this.citiesList}>
                  { cities.map ((city, index) =>
                    <React.Fragment key={city+index}>
                      <Col 
                        className={`tabs no-select ${activeTab === index && "active"} ${deleteLocation === index ? "delete": ""}`} 
                        onClick={() => this.switchTab(city, index)} 
                        onTouchStart={() => !fullScreenActive && this.handleButtonPress(index)} 
                        onTouchEnd={() => this.handleButtonRelease(index)} 
                        onMouseDown={() => !fullScreenActive && this.handleButtonPress(index)} 
                        onMouseUp={() => this.handleButtonRelease(index)} 
                        onMouseLeave={() => this.handleButtonRelease(index)}
                        title={city}
                        id={city}
                        key={city}
                        tabIndex={index+1}
                        // ref={this[`ref${index}`]}
                        // ref={el => (this.citiesRef[index] = el)}
                      >
                        <i className="-map-marker"></i> <span className="city-name">{city}</span> 
                        { deleteLocation === index &&
                          <i className="delete-icon fade-in" title={"Remove "+city} onClick={()=>this.toggleDeleteModal()}>remove</i>
                        }
                      </Col> 
                      { (index === cities.length-1 && cities.length > 1) && <Col className="invisible-tab"></Col>} 
                    </React.Fragment>              
                  )}
                </Row>
                
                { showForecast &&
                  <span>
                    { !fullScreenActive && <Col tabIndex="99" className="tabs add-location pt-0 pl-3" title="Add a new location" onClick={()=> this.toggleLocationModal()}><h2>+</h2></Col>}
                  </span>
                }
                
                <ErrorBoundary msg="Error loading weekly forecast">  
                  <Scrollbar noScrollX={true} disableTracksWidthCompensation={!showForecast} className={`forecast-inner ${!showForecast &&"no-scroll"}`}>    
                    <div 
                      className={`text-left px-4 today-frcst ${todayExpanded ? "closed expanded" : "closed"}`} 
                      onClick={()=> this.expand("today")}
                    > 
                      { forecast ?
                        <Row className="condensed">
                          <Col xs={4} className="day">
                            {/*activeTab > 0 ? (forecast && this.convertToDay(forecast.list[0].dt)) : "Today"*/}Today
                          </Col>
                          <Col xs={4} className="temp text-center">
                            <CountUp 
                              start={0}
                              end={forecast && parseFloat(weatherToday.main.temp).toFixed(0) || 0} 
                              duration={0.2}
                            />°
                          </Col>
                        </Row>
                        :
                        this.loading("forecast")
                      }
                      <AnimatePresence>
                        { todayExpanded &&
                          <motion.div 
                            className="expanded-details row" onClick={(e)=>e.stopPropagation()}
                            initial={{ opacity: 0, height: "0%" }}
                            animate={{ opacity: 1, height: "100%" }}
                            exit={{ opacity: 0, height: "0%" }}
                          >
                            <Col xs={12} className="hourly pl-0">
                              <Scrollbar noScrollY={true} className={`hourly-inner`}>  
                                  {this.generateExpandedCell(forecast, 1)}
                              </Scrollbar>
                            </Col>
                          </motion.div>
                        }
                      </AnimatePresence>
                    </div>
                    
                    <div 
                      className={`text-left px-4 monday ${monExpanded ? "closed expanded" : "closed"}`} 
                      onClick={()=> this.expand("monday")}
                    >
                      { forecast ?
                        <Row className="">
                          <Col xs={4} className="day">
                            {forecast && this.convertToDay(forecast.list[7].dt)}
                          </Col>
                          <Col xs={4} className="temp text-center">
                            <CountUp 
                              start={0}
                              end={forecast && parseFloat(forecast.list[7].main.temp).toFixed(0) || 0} 
                              duration={0.2}
                            />°
                          </Col>
                        </Row>
                        :
                        this.loading("forecast")                  
                        }
                        
                      <AnimatePresence>
                        { monExpanded &&
                          <motion.div 
                            className="expanded-details row" onClick={(e)=>e.stopPropagation()}
                            initial={{ opacity: 0, height: "0%" }}
                            animate={{ opacity: 1, height: "100%" }}
                            exit={{ opacity: 0, height: "0%" }}
                          >
                            <Col xs={12} className="hourly pl-0">
                              <Scrollbar scrollX={true} noScrollY={true} className={`hourly-inner`}>  
                                  {this.generateExpandedCell(forecast, 2)}
                              </Scrollbar>
                            </Col>
                          </motion.div>
                        }
                      </AnimatePresence>
                    </div>
                    
                    <div 
                      className={`text-left px-4 tuesday ${tuesExpanded ? "closed expanded" : "closed"}`}
                      onClick={()=> this.expand("tuesday")}
                    >
                      { forecast ?
                        <Row className="">
                          <Col xs={4} className="day">
                              {forecast && this.convertToDay(forecast.list[15].dt)}
                          </Col>
                          <Col xs={4} className="temp text-center">
                            <CountUp 
                              start={0}
                              end={forecast && parseFloat(forecast.list[15].main.temp).toFixed(0) || 0} 
                              duration={0.2}
                            />°
                          </Col>
                          <Col xs={4} className="symbol text-center">
                          </Col>
                        </Row>
                        :
                        this.loading("forecast")                  
                      }
                      <AnimatePresence>
                        { tuesExpanded &&
                          <motion.div 
                            className="expanded-details row" onClick={(e)=>e.stopPropagation()}
                            initial={{ opacity: 0, height: "0%" }}
                            animate={{ opacity: 1, height: "100%" }}
                            exit={{ opacity: 0, height: "0%" }}
                          >
                            <Col xs={12} className="hourly pl-0">
                              <Scrollbar scrollX={true} noScrollY={true} className={`hourly-inner`}>  
                                  {this.generateExpandedCell(forecast, 3)}
                              </Scrollbar>
                            </Col>
                          </motion.div>
                        }
                      </AnimatePresence>
                    </div>
                    
                    
                  </Scrollbar>
                  {/* </OverlayScrollbarsComponent> */}
                </ErrorBoundary>
              </motion.div> 
            } 
            </AnimatePresence>

            {(showArrows && !this.props.loading) && 
              <Swipeable onSwipedUp={() => this.setState({showForecast: true})}>
                <span className={!showForecast ? "open-forecast" : "close-forecast"} onClick={() => this.toggleForecast()}>
                  {showForecast ? "close":"open"} 
                </span>  
              </Swipeable>
            }
            
            <Modal className={`${theme.color}`} show={showLocationModal} onHide={()=>this.toggleLocationModal()} animation={true} top keyboard>
              <Modal.Header closeButton>
                <Modal.Title><i className="-globe "></i> <span>Add a location</span><i className=""></i></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <input 
                  autoComplete="off"
                  className="city-input" 
                  type="text" 
                  name="city"
                  placeholder="Enter a city or country name" 
                  onChange={(e)=> this.handleChange(e)}
                  onKeyPress={(e)=> this.handleChange(e)}
                  // ref={input => input && input.focus()}
                  ref={this.focusInput}
                  value={newCity} 
                />
                {error ? <span className="error-msg">{errorMsg}</span>: <span className="error-msg">{""}</span>}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={(e)=>this.addLocation(e)}>
                  Add Location
                </Button>
              </Modal.Footer>
            </Modal>
            
            <div className="login-modal">
              <Modal className={`${theme.color} login-modal`} show={showLogin || this.props.showLogin} onHide={()=>this.toggleLogin()} animation={true} centered keyboard>
                <Modal.Header closeButton>
                  <Modal.Title><i className="-sign-in-alt "></i> <span>{"Create an Account"}</span><i className=""></i></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <BeautifulMessage login />
                  { typeof window !== "undefined" && 
                    <Suspense fallback={<center><MoonLoader size={49} margin={49} /></center>}>
                      <AuthCheck fallback={<FirebaseUI />} />
                    </Suspense>
                  }
                  {error ? <span className="error-msg">{errorMsg}</span>: <span className="error-msg">{""}</span>}
                </Modal.Body>
              </Modal>
            </div>
            
            <div className="delete">
              <Modal className={`delete-modal ${theme.color}`} show={showDeleteModal} onHide={()=>this.toggleDeleteModal()} animation={true} centered keyboard>
                <Modal.Header closeButton>
                  <Modal.Title><i className="-trash-alt "></i> <span>Delete location</span> <i className=""></i> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Are you sure you want to delete <b>{cities[deleteLocation]}</b>?</p>              
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={(e)=>this.toggleDeleteModal()}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={(e)=>this.confirmDeleteLocation(e)}>
                    Delete Location
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          
        </div>
      </Fullscreen>
      )}
    </ThemeContext.Consumer>
    
  }
}

const memoWeather = React.memo(Weather);
export default memoWeather;
